import { useApolloClient, useQuery } from '@apollo/client';
import { PreRenderQuery, PreRenderQueryVariables, PreRenderQueryHookResult } from '@catalogo/core-types';
import { CookiesAndHeaders, PreRender } from './query.graphql';
import { getVariablesSegments, getVariablesRegion, getVariablesExperiments } from './helpers';

interface usePreRenderArguments {
  skipSegments: boolean;
}

export const usePreRender = (config: usePreRenderArguments): PreRenderQueryHookResult => {
  const client = useApolloClient();
  const cah = client.readQuery({
    query: CookiesAndHeaders,
  });

  const variables = {
    ...getVariablesRegion(cah),
    ...getVariablesSegments(cah),
    ...getVariablesExperiments(cah),
    skipSegments: config.skipSegments,
  };

  return useQuery<PreRenderQuery, PreRenderQueryVariables>(PreRender, {
    variables,
  });
};
